(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["er-model-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('er-model-input')) {
    customElements.define('er-model-input', class extends HTMLElement {
      static KEY = /^[a-z0-9-]{1,32}$/;
      static NUMBER = /^A\d{4}$/;
      static PARTIAL = /^(A\d{0,3}|\d{0,3})$/;

      // Gedeelde helpers (ook gebruikt door er-model-help). Ze veranderen nooit een conditie en nooit de
      // select zelf: kiezen gaat uitsluitend via de generatie-radio + change, net als een tik op de tegel.
      static normalize(raw) {
        let text = String(raw ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '').replace(/O/g, '0');
        if (/^\d{4}$/.test(text)) text = `A${text}`;
        return text;
      }

      static fill(template, values) {
        return String(template || '').replace(/\{(\w+)\}/g, (match, name) =>
          (Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match));
      }

      static data(node) {
        const scope = node.closest('er-native-options') || node.closest('[data-er-model-scope]') || node.ownerDocument;
        const script = scope.querySelector('[data-er-model-numbers]');
        if (!script) return null;
        let parsed = null;
        try {
          parsed = JSON.parse(script.textContent || 'null');
        } catch (error) {
          parsed = null;
        }
        if (!parsed || typeof parsed !== 'object' || !parsed.models || typeof parsed.models !== 'object'
          || !parsed.aliases || typeof parsed.aliases !== 'object') return null;
        return parsed;
      }

      // Sleutel(s) bij een genormaliseerd nummer: één, of twee kandidaten (kommagescheiden in de bron). Nooit meer dan twee.
      static keysFor(data, number) {
        if (!data || !Object.prototype.hasOwnProperty.call(data.aliases, number)) return [];
        const raw = data.aliases[number];
        if (typeof raw !== 'string') return [];
        const keys = [];
        for (const part of raw.split(',')) {
          const key = part.trim();
          if (this.KEY.test(key) && Object.prototype.hasOwnProperty.call(data.models, key) && !keys.includes(key)) keys.push(key);
        }
        return keys.slice(0, 2);
      }

      static label(data, key) {
        const model = data && data.models ? data.models[key] : null;
        return model && typeof model.label === 'string' && model.label ? model.label : key;
      }

      // De generatietegel (radio met data-er-gen-key) in de kiezer waar dit element in staat; null daarbuiten.
      static tile(node, key) {
        if (!this.KEY.test(key)) return null;
        const scope = node.closest('er-native-options');
        if (!scope) return null;
        return Array.from(scope.querySelectorAll('input[type="radio"][data-er-gen-key]'))
          .find((radio) => radio.dataset.erGenKey === key) || null;
      }

      static pick(node, key) {
        const radio = this.tile(node, key);
        if (!radio) return false;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      // H2.018 (26-09-2026): met #bestelbox landt de klant meteen op de bestelbox van de homepage (het anker
      // id="bestelbox" van er-home-buybox), nog vóór het uitgestelde script van de kiezer geladen is. Daarna zet
      // applyQuery() van er-native-options de generatie voor via ?model=<sleutel> en scrolt hij zo nodig alsnog
      // zacht naar [data-er-buybox] (C9, 22-09). De tegels van er-part-funnel (zoekpagina, 404) dragen dit anker al.
      // 09-10-2026 (ronde O, o9/o9b): met het onderdeel dat de klant zelf kiest ook ?onderdeel= (applyQuery kent links,
      // rechts en case).
      static pickerUrl(root, key, part) {
        const base = typeof root === 'string' && root.startsWith('/') ? root : '/';
        const deel = ['links', 'rechts', 'case'].includes(part) ? `&onderdeel=${part}` : '';
        return `${base}${base.endsWith('/') ? '' : '/'}?model=${encodeURIComponent(key)}${deel}#bestelbox`;
      }

      // 09-10-2026 (ronde O, o9; o9b: alleen nog voor de uitlegregel, nooit om voor te zetten, want het nummer is van het
      // onderdeel dat de klant nog heeft): het onderdeel dat het nummer aanwijst. 'case' bij een casenummer van deze generatie
      // (behalve A1938: de draadloze case is een eigen product, de kiezer kent als case van AirPods 1/2 alleen A1602);
      // 'links' of 'rechts' bij het nummer van die kant (data-kant uit er-kant-nummers). Anders '' (alleen het model).
      static partFor(node, data, key, number) {
        const model = data && data.models ? data.models[key] : null;
        if (number !== 'A1938' && model && Array.isArray(model.case) && model.case.includes(number)) return 'case';
        const host = node.closest('er-model-input');
        const raw = host && host.dataset ? host.dataset.kant || '' : '';
        for (const entry of raw.split(';')) {
          const [entryKey, pair] = entry.split('=');
          if (entryKey !== key || !pair) continue;
          const [left, right] = pair.split('|').map((value) => value.trim());
          if (number === left) return 'links';
          if (number === right) return 'rechts';
        }
        return '';
      }

      // 09-10-2026 (ronde O, o11; KRITIEK-RONDE-O4 #1): een herkend nummer onthouden voor het modelnummerveld in de winkelwagen
      // (sections/er-cart-extra vult het daar alvast in; de klant slaat het zelf op). Alleen deze sessie, alleen het nummer.
      static remember(number) {
        try {
          window.sessionStorage.setItem('er-a-nummer', number);
        } catch (error) {
          // Opslag geblokkeerd: dan onthouden we niets.
        }
      }

      // Eén keuze: knop in een kiezer (vinkt de tegel aan), link naar de kiezer daarbuiten.
      static choice(node, key, text, root, part) {
        const inPicker = !!this.tile(node, key);
        const element = document.createElement(inPicker ? 'button' : 'a');
        element.className = 'er-model-choice';
        element.textContent = text;
        if (inPicker) {
          element.type = 'button';
          element.dataset.erPick = key;
        } else {
          element.href = this.pickerUrl(root, key, part);
          element.dataset.erPickLink = key;
        }
        return element;
      }

      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.input = this.querySelector('[data-er-model-input]');
        this.result = this.querySelector('[data-er-model-result]');
        if (!this.input || !this.result) return;
        this.last = '';
        this.number = '';
        // B9: de tegel die deze invoer zelf aanvinkte; null zodra iets anders een generatietegel kiest.
        this.picked = null;
        this.picking = false;
        this.input.addEventListener('input', () => this.evaluate(false), { signal });
        this.input.addEventListener('change', () => this.evaluate(true), { signal });
        this.input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          // In de bestelbox staat dit veld in het bestelformulier: Enter mag nooit een toevoeging worden.
          event.preventDefault();
          // C9: toetsenbord sluiten vóór de herkenning. De kiezer scrolt hierna zelf naar de volgende vraag of
          // naar de koopknop; met een open toetsenbord landt die scroll erachter. blur() stuurt zelf al een
          // change (de waarde is veranderd), dus evaluate loopt één keer: de tweede stopt op number === last.
          this.input.blur();
          this.evaluate(true);
        }, { signal });
        this.result.addEventListener('click', (event) => {
          const button = event.target instanceof Element ? event.target.closest('[data-er-pick]') : null;
          if (!button || !this.result.contains(button)) return;
          this.choose(button.dataset.erPick || '');
        }, { signal });
        // B9: kiest daarna iets anders een generatietegel (een tik of Enter van de klant, de uiterlijkvragen),
        // dan is die keuze niet meer van deze invoer en blijft hij bij een latere melding gewoon staan.
        const picker = this.closest('er-native-options');
        if (picker) {
          const forget = (event) => {
            const target = event.target;
            if (this.picking || !(target instanceof HTMLInputElement) || target.type !== 'radio'
              || typeof target.dataset.erGenKey !== 'string') return;
            this.picked = null;
          };
          picker.addEventListener('change', forget, { signal });
          picker.addEventListener('click', forget, { signal });
        }
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
      }

      // o11 (ronde O, KRITIEK-RONDE-O3 #3): de keuzes staan als eigen rij onder de zin; voorheen hing de eerste knop aan de
      // zin en vielen de andere eronder, afhankelijk van de zinslengte.
      render(text, elements) {
        this.result.textContent = text;
        if (!elements.length) return;
        const rij = document.createElement('span');
        rij.className = 'er-model-input__choices';
        for (const element of elements) rij.append(element);
        this.result.append(' ', rij);
      }

      evaluate(final) {
        const helper = this.constructor;
        const number = helper.normalize(this.input.value);
        if (!number || (!final && !helper.NUMBER.test(number) && helper.PARTIAL.test(number))) {
          // Leeg, of nog aan het typen (A, A2, A26, A269): niets melden tot het nummer compleet is.
          this.last = '';
          this.render('', []);
          return;
        }
        if (number === this.last) return;
        this.last = number;
        this.number = number;
        this.data = helper.data(this);
        const keys = helper.keysFor(this.data, number);
        const root = this.dataset.root || '/';
        // o11 (KRITIEK-RONDE-O4 #1): herkend (ook AirPods 5) -> onthouden voor de winkelwagen.
        if (keys.length > 0 || /^A(353[0-3]|3529|3439|344[01])$/.test(number)) helper.remember(number);
        if (keys.length === 0) {
          this.release();
          // 27-09-2026 (ronde I, I2.2): AirPods 5-nummers -> de AirPods 5-collectie (de kiezerdata kent ze niet).
          if (/^A(353[0-3]|3529|3439|344[01])$/.test(number) && this.dataset.ap5) {
            const link = document.createElement('a');
            link.className = 'link';
            link.href = root + (root.endsWith('/') ? '' : '/') + 'collections/airpods-5-losse-onderdelen';
            link.textContent = this.dataset.ap5Link || '';
            const wat = /^A353[123]$/.test(number) ? this.dataset.ap5StdBud
              : /^A(3439|344[01])$/.test(number) ? this.dataset.ap5WccBud
              : number === 'A3530' ? this.dataset.ap5StdCase : this.dataset.ap5WccCase;
            this.render(helper.fill(this.dataset.ap5, { number, wat: wat || '' }), [link]);
            return;
          }
          // 11-10-2026 (ronde R, R1.11): onbekend nummer -> ook een WhatsApp-link met wat de klant typte al in het bericht.
          // Nieuw venster, zoals de bubbel; zonder de data-attributen alleen de tekst, zoals voorheen.
          const hulp = [];
          if (this.dataset.waUrl && this.dataset.waLink) {
            const wa = document.createElement('a');
            wa.className = 'link er-model-input__wa';
            const getypt = String(this.input.value || '').trim().slice(0, 12) || number;
            wa.href = this.dataset.waUrl + encodeURIComponent(helper.fill(this.dataset.waText || '', { number: getypt }));
            wa.target = '_blank';
            wa.rel = 'noopener';
            wa.textContent = this.dataset.waLink;
            if (document.getElementById('a11y-new-window-message')) wa.setAttribute('aria-describedby', 'a11y-new-window-message');
            hulp.push(wa);
          }
          this.render(this.dataset.unknown || '', hulp);
          return;
        }
        if (keys.length === 1) {
          const label = helper.label(this.data, keys[0]);
          if (this.pickTile(keys[0])) {
            this.render(helper.fill(this.dataset.found, { number, label }), []);
          } else {
            // 09-10-2026 (ronde O, o9b): drie keuzes met het model vooraf; de klant kiest zelf wat hij mist. De regel zegt
            // welk onderdeel het nummer is (dat heeft hij nog), zonder dat onderdeel voor te zetten. Ontbreekt een tekst,
            // dan zoals vóór o9: één link 'Naar de kiezer' met alleen het model.
            const part = helper.partFor(this, this.data, keys[0], number);
            const deel = part === 'links' ? this.dataset.partLinks : part === 'rechts' ? this.dataset.partRechts
              : part === 'case' ? this.dataset.partCase
              // o11 (KRITIEK-RONDE-O4 klein 1): regionaal derde nummer = een oortje van onbekende kant.
              : (this.data && this.data.models && this.data.models[keys[0]]
                && Array.isArray(this.data.models[keys[0]].earbuds) && this.data.models[keys[0]].earbuds.includes(number))
                ? this.dataset.partOortje || '' : '';
            const picks = [['links', this.dataset.pickLinks], ['case', this.dataset.pickCase], ['rechts', this.dataset.pickRechts]]
              .filter(([, text]) => text)
              .map(([value, text]) => helper.choice(this, keys[0], text, root, value));
            if (picks.length === 3 && this.dataset.foundPick) {
              this.render(helper.fill(deel && this.dataset.foundPart ? this.dataset.foundPart : this.dataset.foundPick,
                { number, label, deel: deel || '' }), picks);
            } else {
              this.render(helper.fill(this.dataset.foundLink, { number, label }),
                [helper.choice(this, keys[0], this.dataset.toPicker || '', root)]);
            }
          }
          return;
        }
        this.release();
        const labels = keys.map((key) => helper.label(this.data, key));
        // I2.41: AirPods 1 en 2 (A1602/A1938): de tekst met de beslissende zin.
        const two = keys.includes('ap1') && keys.includes('ap2') && this.dataset.foundTwoAp12
          ? this.dataset.foundTwoAp12 : this.dataset.foundTwo;
        const choices = keys.map((key, index) => helper.choice(this, key, labels[index], root));
        // I2.50: bij A1938 ook de link naar de draadloze oplaadcase zelf.
        if (number === 'A1938' && this.dataset.a1938Url) {
          const link = document.createElement('a');
          link.className = 'link';
          link.href = this.dataset.a1938Url;
          link.textContent = this.dataset.a1938Link || '';
          choices.push(link);
        }
        this.render(helper.fill(two, { number, label1: labels[0], label2: labels[1] }), choices);
      }

      choose(key) {
        const helper = this.constructor;
        if (!this.pickTile(key)) return;
        this.render(helper.fill(this.dataset.found, { number: this.number, label: helper.label(this.data, key) }), []);
      }

      // B9: tegel aanvinken via de gedeelde helper en onthouden dat deze invoer hem koos. Het change-event van
      // die helper zelf telt niet als "iets anders koos" (this.picking).
      pickTile(key) {
        const helper = this.constructor;
        const radio = helper.tile(this, key);
        let picked = false;
        this.picking = true;
        try {
          picked = helper.pick(this, key);
        } finally {
          this.picking = false;
        }
        if (picked) this.picked = radio;
        return picked;
      }

      // B9: de tegel die deze invoer koos weer uitvinken, alleen als hij nog aan staat en nog van deze invoer is.
      // Zelfde weg als een tik: checked + change-event; er-native-options zet daarna zelf de select op leeg.
      release() {
        const radio = this.picked;
        this.picked = null;
        if (!(radio instanceof HTMLInputElement) || !radio.isConnected || !radio.checked) return;
        radio.checked = false;
        this.picking = true;
        try {
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
          this.picking = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["er-native-advisory-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('er-native-advisory-product')) {
    customElements.define('er-native-advisory-product', class extends HTMLElement {
      static variant(productId, options, id, country) {
        const integer = (value) => /^(0|[1-9][0-9]*)$/.test(String(value)) && Number.isSafeInteger(Number(value));
        if (!integer(productId) || Number(productId) < 1 || !integer(id) || Number(id) < 1 || !['NL', 'BE', 'FR'].includes(country)) return null;
        const matches = options.filter((option) => option.value === id);
        if (matches.length !== 1) return null;
        const option = matches[0];
        const data = option.dataset;
        // 18-10-2026 (AP5-overal): een AirPods 5-regel (data-er-extra="ap5", snippets/er-kiezer-airpods5) hoort bij een eigen product.
        const extra = data.erExtra === 'ap5' && integer(data.productId) && Number(data.productId) > 0;
        if (option.disabled || (data.productId !== productId && !extra) || data.available !== 'true') return null;
        if (typeof data.label !== 'string' || data.label.trim() === '') return null;
        if (typeof data.money !== 'string' || data.money.trim() === '') return null;
        if (!integer(data.price) || !integer(data.min) || Number(data.min) < 1 || !integer(data.step) || Number(data.step) < 1) return null;
        if (data.max !== '' && (!integer(data.max) || Number(data.max) < Number(data.min))) return null;
        const short = typeof data.moneyShort === 'string' && data.moneyShort.trim() !== '' ? data.moneyShort : data.money;
        return { id, productId: extra ? data.productId : productId, price: Number(data.price), money: data.money, short, min: data.min, max: data.max, step: data.step };
      }

      static selection(productId, options, id, quantity, country) {
        const variant = this.variant(productId, options, id, country);
        if (!variant || !/^(0|[1-9][0-9]*)$/.test(String(quantity)) || !Number.isSafeInteger(Number(quantity))) return null;
        if (Number(quantity) < Number(variant.min) || Number(quantity) % Number(variant.step) !== 0) return null;
        if (variant.max !== '' && Number(quantity) > Number(variant.max)) return null;
        return { id, productId: variant.productId, quantity: Number(quantity), price: variant.price, money: variant.money };
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        this.select = this.querySelector('[data-native-variant]');
        this.quantity = this.querySelector('[data-native-quantity]');
        this.button = this.querySelector('[data-native-add]');
        this.status = this.querySelector('[data-native-status]');
        this.price = this.querySelector('[data-native-price]');
        this.availability = this.querySelector('[data-native-availability]');
        // Ronde U (u1): de conditieregel onder de vanaf-prijs; niet verplicht (zonder het element werkt alles zoals voorheen).
        this.cond = this.querySelector('[data-native-cond]');
        this.quantityError = this.querySelector('[data-native-quantity-error]');
        if (!this.form || !this.select || !this.quantity || !this.button || !this.status || !this.price || !this.availability || !this.quantityError) return;
        this.abort?.abort();
        this.abort = new AbortController();
        this.select.value = '';
        this.pending ??= false;
        this.uncertain ??= false;
        this.navigating ??= false;
        this.form.addEventListener('submit', (event) => this.submit(event), { signal: this.abort.signal });
        this.select.addEventListener('change', () => this.refresh(true), { signal: this.abort.signal });
        this.quantity.addEventListener('input', () => this.refresh(false), { signal: this.abort.signal });
        // Ronde N (N2 = M4, 09-10-2026): terug uit de bfcache na 'Toegevoegd' bleef navigating true, en daarmee bleven de keuzelijst
        // en de knop uit (refresh). Bij een herstel uit de bfcache begint de kaart weer vrij; de wagen zelf is al bijgewerkt.
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted) return;
          this.pending = false;
          this.uncertain = false;
          this.navigating = false;
          this.status.textContent = '';
          this.refresh(false);
        }, { signal: this.abort.signal });
        this.refresh(true);
      }

      disconnectedCallback() { this.abort?.abort(); }

      current() {
        if (this.dataset.version !== 'er-native-advisory/1') return null;
        return this.constructor.selection(this.dataset.productId, Array.from(this.select.options), this.select.value, this.quantity.value, this.dataset.country);
      }

      refresh(resetQuantity) {
        if (resetQuantity) {
          const option = Array.from(this.select.options).filter((entry) => entry.value === this.select.value);
          this.quantity.value = option.length === 1 ? option[0].dataset.min || '1' : '1';
        }
        const current = this.current();
        const variant = this.dataset.version === 'er-native-advisory/1' && this.constructor.variant(this.dataset.productId, Array.from(this.select.options), this.select.value, this.dataset.country);
        this.price.textContent = variant?.money || this.dataset.fromPrice || '—';
        // Ronde U (u1, KRITIEK-RONDE-T19 klein 2): de conditie waar de vanaf-prijs bij hoort (er-native-options houdt data-from-price en
        // data-from-cond bij de keuze bij); weg zodra er een variant gekozen is, want dan staat de exacte prijs er.
        if (this.cond) this.cond.textContent = variant ? '' : this.dataset.fromCond || '';
        this.button.textContent = variant ? `${this.dataset.addLabel} · ${variant.short}` : this.dataset.addLabel;
        this.availability.textContent = variant ? this.dataset.available : '';
        this.quantityError.hidden = !variant || !!current;
        this.quantityError.textContent = variant && !current ? this.dataset.quantityError : '';
        this.quantity.setAttribute('aria-invalid', String(!!variant && !current));
        this.quantity.disabled = !variant || this.pending || this.uncertain || this.navigating;
        this.button.disabled = !current || this.pending || this.uncertain || this.navigating || this.dataset.previewOnly !== 'false';
        this.select.disabled = this.pending || this.uncertain || this.navigating;
        if (variant) {
          const data = variant;
          this.quantity.min = data.min;
          this.quantity.step = data.step;
          if (data.max === '') this.quantity.removeAttribute('max');
          else this.quantity.max = data.max;
        }
      }

      async submit(event) {
        event.preventDefault();
        const selected = this.current();
        if (!selected || this.pending || this.uncertain || this.navigating || this.dataset.previewOnly !== 'false') return;
        let endpoint;
        let destination;
        try {
          endpoint = new URL(this.dataset.addUrl, window.location.origin);
          destination = new URL(this.dataset.cartUrl, window.location.origin);
        } catch { return; }
        if (endpoint.origin !== window.location.origin || !endpoint.pathname.endsWith('/cart/add.js') || endpoint.search || endpoint.hash) return;
        if (destination.origin !== window.location.origin || destination.pathname !== endpoint.pathname.replace(/\/add\.js$/, '') || destination.hash) return;
        if (destination.search !== '' && destination.search !== '?view=er-native-advisory-v1') return;
        this.pending = true;
        this.status.textContent = '';
        this.refresh(false);
        try {
          const response = await fetch(endpoint.href, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(selected.id), quantity: selected.quantity, properties: { _er_native_route: 'er-native-advisory/1' } }] }),
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            this.uncertain = true;
            this.status.textContent = `${typeof result.description === 'string' ? result.description : this.dataset.error} ${this.dataset.uncertain}`;
            return;
          }
          if (!Array.isArray(result.items) || result.items.length !== 1 || String(result.items[0].variant_id ?? result.items[0].id) !== selected.id || String(result.items[0].product_id) !== selected.productId) throw new Error('Response identity mismatch');
          if (!Number.isSafeInteger(result.items[0].quantity) || result.items[0].quantity < selected.quantity) throw new Error('Response quantity mismatch');
          this.status.textContent = this.dataset.added;
          this.navigating = true;
          this.refresh(false);
          window.location.assign(destination.href);
        } catch {
          this.uncertain = true;
          this.status.textContent = this.dataset.uncertain;
        } finally {
          this.pending = false;
          this.refresh(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["er-native-options-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('er-model-help')) {
    customElements.define('er-model-help', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const start = () => {
          if (!this.abort || this.abort.signal.aborted) return;
          this.setup(this.abort.signal);
        };
        if (customElements.get('er-model-input')) start();
        else customElements.whenDefined('er-model-input').then(start);
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
      }

      setup(signal) {
        this.helpers = customElements.get('er-model-input');
        this.details = this.querySelector('details');
        this.result = this.querySelector('[data-er-look-result]');
        const host = this.querySelector('[data-er-look]');
        // Geopend via de hulplink in de hero terwijl stap 2 nog verborgen is (stepper): bestelbox in beeld.
        this.details?.addEventListener('toggle', () => this.reveal(), { signal });
        this.shadow = host ? this.ensureShadow(host) : null;
        if (!this.helpers || !this.shadow || !this.result) return;
        this.radios = Array.from(this.shadow.querySelectorAll('input[type="radio"]'));
        this.shadow.addEventListener('change', (event) => {
          const radio = event.target;
          if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
          this.answer(radio);
        }, { signal });
        this.result.addEventListener('click', (event) => {
          const button = event.target instanceof Element ? event.target.closest('[data-er-pick]') : null;
          if (!button || !this.result.contains(button)) return;
          const key = button.dataset.erPick || '';
          this.picking = true;
          let gekozen = false;
          try {
            gekozen = this.helpers.pick(this, key);
          } finally {
            this.picking = false;
          }
          if (gekozen) {
            this.picked = this.helpers.tile(this, key);
            this.result.textContent = this.helpers.fill(this.dataset.chosen, { label: this.helpers.label(this.helpers.data(this), key) });
          }
        }, { signal });
        // I2.58 (KRITIEK-RONDE-I12 #2): kiest daarna iets anders een generatietegel (tik, Enter of de typinvoer), dan is die
        // keuze niet meer van de vragen en blijft hij staan (zoals B9 in er-model-input).
        const picker = this.closest('er-native-options');
        if (picker) {
          const forget = (event) => {
            const target = event.target;
            if (this.picking || !(target instanceof HTMLInputElement) || target.type !== 'radio'
              || typeof target.dataset.erGenKey !== 'string') return;
            this.picked = null;
          };
          picker.addEventListener('change', forget, { signal });
          picker.addEventListener('click', forget, { signal });
        }
        this.update();
      }

      // Declaratieve shadow root (template[shadowrootmode]); in browsers of renderpaden zonder ondersteuning
      // (of na innerHTML in de thema-editor) wordt de template hier alsnog aan een shadow root gehangen.
      ensureShadow(host) {
        if (host.shadowRoot) return host.shadowRoot;
        const template = host.querySelector(':scope > template[shadowrootmode]');
        if (!template) return null;
        try {
          const shadow = host.attachShadow({ mode: 'open' });
          shadow.append(template.content);
          template.remove();
          return shadow;
        } catch (error) {
          return null;
        }
      }

      reveal() {
        if (!this.details?.open || this.details.getClientRects().length > 0) return;
        const box = this.closest('[data-er-buybox]') || this.closest('er-native-advisory-product');
        if (!box) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }

      step(radio) {
        return Number(radio.closest('fieldset')?.dataset.erLookStep || 0);
      }

      branch(radio) {
        return radio.closest('fieldset')?.dataset.erLookBranch || '';
      }

      // Een antwoord wist de antwoorden op de vervolgvragen; daarna worden zichtbaarheid en resultaat opnieuw bepaald.
      answer(radio) {
        const step = this.step(radio);
        for (const other of this.radios) {
          if (this.step(other) > step) other.checked = false;
        }
        this.update();
      }

      checked(step, branch) {
        return this.radios.find((radio) => radio.checked && this.step(radio) === step
          && (step === 1 || this.branch(radio) === branch)) || null;
      }

      showBranch(step, branch) {
        for (const fieldset of this.shadow.querySelectorAll(`fieldset[data-er-look-step="${step}"]`)) {
          fieldset.hidden = !branch || fieldset.dataset.erLookBranch !== branch;
        }
      }

      update() {
        const first = this.checked(1, '');
        const branch2 = first?.dataset.erNext || '';
        this.showBranch(2, branch2);
        const second = branch2 ? this.checked(2, branch2) : null;
        const branch3 = second?.dataset.erNext || '';
        this.showBranch(3, branch3);
        const third = branch3 ? this.checked(3, branch3) : null;
        // I2.39: vierde vraag (nummer in het deksel) na 'kort steeltje + USB-C'.
        const branch4 = third?.dataset.erNext || '';
        this.showBranch(4, branch4);
        const fourth = branch4 ? this.checked(4, branch4) : null;
        const leaf = [fourth, third, second, first].find((radio) => radio && (radio.dataset.erKeys || radio.dataset.erHref)) || null;
        this.showResult(leaf);
      }

      // Resultaat: één knop ("Kies …") of twee knoppen met de modelnamen; buiten een kiezer links naar de kiezer.
      release() {
        const radio = this.picked;
        this.picked = null;
        if (!(radio instanceof HTMLInputElement) || !radio.isConnected || !radio.checked) return;
        radio.checked = false;
        this.picking = true;
        try {
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
          this.picking = false;
        }
      }

      showResult(leaf) {
        const helpers = this.helpers;
        this.result.textContent = '';
        // I2.51 (KRITIEK-RONDE-I10 #4): een ander blad (AirPods 5, een ander model of geen antwoord) laat de eerder via een
        // knop gekozen tegel niet staan; zelfde weg als release() (B9) in er-model-input.
        const leafKeys = leaf ? String(leaf.dataset.erKeys || '').split(',').map((key) => key.trim()) : [];
        if (this.picked && !leafKeys.includes(this.picked.dataset.erGenKey || '')) this.release();
        if (!leaf) return;
        // I2.39: AirPods 5 zit niet in de kiezer; dan een link naar de AirPods 5-collectie (zoals de invoer, er-model-input).
        if (leaf.dataset.erHref) {
          const link = document.createElement('a');
          link.className = 'link';
          link.href = leaf.dataset.erHref;
          link.textContent = leaf.dataset.erLink || '';
          this.result.textContent = leaf.dataset.erNote || '';
          this.result.append(' ', link);
          return;
        }
        const keys = String(leaf.dataset.erKeys || '').split(',')
          .map((key) => key.trim())
          .filter((key, index, all) => helpers.KEY.test(key) && all.indexOf(key) === index)
          .slice(0, 2);
        if (keys.length === 0) return;
        const data = helpers.data(this);
        const root = this.dataset.root || '/';
        if (keys.length === 1) {
          const label = helpers.label(data, keys[0]);
          const inPicker = !!helpers.tile(this, keys[0]);
          // o11 (ronde O, KRITIEK-RONDE-O4 klein 2): buiten een kiezer drie keuzes met het model vooraf, zoals er-model-input (o9b).
          if (!inPicker && this.dataset.singlePick && this.dataset.pickLinks && this.dataset.pickCase && this.dataset.pickRechts) {
            this.result.textContent = helpers.fill(this.dataset.singlePick, { label });
            // Als eigen rij onder de zin (KRITIEK-RONDE-O3 #3), zoals er-model-input render().
            const rij = document.createElement('span');
            rij.className = 'er-model-input__choices';
            [['links', this.dataset.pickLinks], ['case', this.dataset.pickCase], ['rechts', this.dataset.pickRechts]]
              .forEach(([part, text]) => rij.append(helpers.choice(this, keys[0], text, root, part)));
            this.result.append(' ', rij);
            return;
          }
          this.result.textContent = helpers.fill(this.dataset.single, { label });
          this.result.append(' ', helpers.choice(this, keys[0], inPicker ? helpers.fill(this.dataset.pick, { label }) : (this.dataset.toPicker || ''), root));
          return;
        }
        this.result.textContent = leaf.dataset.erNote || '';
        for (const key of keys) this.result.append(' ', helpers.choice(this, key, helpers.label(data, key), root));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["er-native-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('er-native-options')) {
    customElements.define('er-native-options', class extends HTMLElement {
      static FINDER_VALUES = {
        earbud_L: ['links', 'left', 'gauche'],
        earbud_R: ['rechts', 'right', 'droite', 'droit'],
        case: ['oplaadcase', 'charging case', 'case', 'boîtier de charge', 'boitier de charge', 'boîtier', 'boitier'],
      };

      static CONDITION_KEYS = {
        nieuwstaat: 'nieuwstaat', 'like new': 'nieuwstaat', 'as new': 'nieuwstaat', 'comme neuf': 'nieuwstaat',
        uitstekend: 'uitstekend', excellent: 'uitstekend',
        goed: 'goed', good: 'goed', bon: 'goed',
        gebruikt: 'gebruikt', used: 'gebruikt', 'utilisé': 'gebruikt', utilise: 'gebruikt',
        beperkt: 'beperkt', limited: 'beperkt', 'limité': 'beperkt', limite: 'beperkt',
      };

      static PART_VALUES = {
        case: ['oplaadcase', 'charging case', 'boîtier de charge', 'boitier de charge'],
        earbud: ['links', 'rechts', 'left', 'right', 'gauche', 'droit', 'droite'],
      };

      // v2: URL-voorkeuze ?onderdeel=links|case|rechts -> sleutel in FINDER_VALUES (alleen homepage-bestelbox).
      static QUERY_PARTS = { links: 'earbud_L', rechts: 'earbud_R', case: 'case' };

      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const start = () => {
          if (signal.aborted) return;
          // Microtask in plaats van requestAnimationFrame: rAF loopt niet in een verborgen of voorgerenderd
          // tabblad, waardoor de knoppen daar pas bij zichtbaar worden verschenen (gemeten 15-09).
          queueMicrotask(() => this.setup(signal));
        };
        if (window.customElements.get('er-native-advisory-product')) start();
        else window.customElements.whenDefined('er-native-advisory-product').then(start);
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.ready = false;
      }

      setup(signal) {
        if (this.ready) return;
        this.host = this.closest('er-native-advisory-product');
        this.select = this.host?.querySelector('[data-native-variant]');
        let map = null;
        try {
          map = JSON.parse(this.querySelector('[data-er-options-map]')?.textContent || 'null');
        } catch (error) {
          map = null;
        }
        if (!this.host || !this.select || !Array.isArray(map) || map.length === 0) return;
        this.groups = Array.from(this.querySelectorAll('[data-er-option-index]'));
        // v2: de DOM-volgorde is de toonvolgorde (onderdeel -> model -> conditie); de optie-index op elke
        // groep is de enige bron voor de koppeling met de variantopties. Klopt de set indexen niet (elke
        // index 0..n-1 precies één keer), dan blijft de keuzelijst zichtbaar en doet dit element niets.
        const indices = this.groups.map((group) => this.optionIndex(group));
        const consistent = indices.every((index, position) => Number.isInteger(index) && index >= 0
          && index < this.groups.length && indices.indexOf(index) === position);
        if (!consistent) return;
        this.map = map.filter((entry) => entry && typeof entry.id === 'string' && Array.isArray(entry.o)
          && entry.o.length === this.groups.length);
        if (this.map.length !== map.length) return;
        this.note = this.querySelector('[data-er-options-note]');
        this.redirect = this.querySelector('[data-er-options-redirect]');
        this.conditionInfo = this.querySelector('[data-er-condition-info]');
        this.compat = this.querySelector('[data-er-compat-line]');
        try {
          this.conditionTexts = JSON.parse(this.querySelector('[data-er-condition-texts]')?.textContent || 'null');
        } catch (error) {
          this.conditionTexts = null;
        }
        try {
          this.models = JSON.parse(this.querySelector('[data-er-model-numbers]')?.textContent || 'null');
        } catch (error) {
          this.models = null;
        }
        this.conditionGroup = this.groups.find((group) =>
          /conditi|conditie|condition|état|etat/i.test(group.querySelector('legend')?.textContent || '')) || null;
        this.conditionIndex = this.conditionGroup ? this.optionIndex(this.conditionGroup) : -1;
        this.generationGroup = this.groups.find((group) => group.dataset.erGeneration === 'true') || null;
        this.generationIndex = this.generationGroup ? this.optionIndex(this.generationGroup) : -1;
        this.partIndex = this.findPartIndex();
        this.ready = true;

        for (const group of this.groups) {
          const radios = group.querySelectorAll('input[type="radio"]');
          if (radios.length === 1) radios[0].checked = true;
        }

        this.addEventListener('change', (event) => {
          if (event.target instanceof HTMLInputElement && event.target.type === 'radio') {
            // 18-10-2026 (AP5-overal): een conditie die de klant zelf kiest, is geen automatische keuze meer (applyExtra).
            if (this.conditionGroup && this.conditionGroup.contains(event.target)) this.autoCondition = null;
            this.sync(true);
          }
        }, { signal });
        // Enter op een knop kiest die knop (zoals de spatiebalk) in plaats van het formulier te versturen.
        this.addEventListener('keydown', (event) => {
          const target = event.target;
          if (event.key !== 'Enter' || !(target instanceof HTMLInputElement) || target.type !== 'radio') return;
          event.preventDefault();
          if (target.checked) return;
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal });
        window.addEventListener('pageshow', () => this.sync(false), { signal });
        if (this.dataset.listenFinder === 'true') {
          document.addEventListener('er:finder-part', (event) => this.preselect(event.detail?.part), { signal });
        }

        const label = this.select.id ? this.host.querySelector(`label[for="${CSS.escape(this.select.id)}"]`) : null;
        label?.setAttribute('hidden', '');
        this.select.setAttribute('hidden', '');
        this.hidden = false;
        this.sync(this.groups.length === 0 || this.chosen().every((value) => value !== null));
        if (this.dataset.listenFinder === 'true') this.applyQuery();
      }

      optionIndex(group) {
        return Number(group.dataset.erOptionIndex);
      }

      // De onderdeelgroep: de groep waarvan alle knopwaarden een onderdeel zijn (Links/Rechts/Oplaadcase).
      findPartIndex() {
        const known = [...this.constructor.PART_VALUES.case, ...this.constructor.PART_VALUES.earbud];
        const group = this.groups.find((candidate) => {
          const values = Array.from(candidate.querySelectorAll('input[type="radio"]'))
            .map((radio) => radio.value.trim().toLowerCase());
          return values.length > 0 && values.every((value) => known.includes(value));
        });
        return group ? this.optionIndex(group) : -1;
      }

      // Gekozen waarde per optie-index (niet per DOM-positie); null als die vraag nog open is.
      chosen() {
        const chosen = new Array(this.groups.length).fill(null);
        for (const group of this.groups) {
          chosen[this.optionIndex(group)] = group.querySelector('input[type="radio"]:checked')?.value ?? null;
        }
        return chosen;
      }

      matching(probe) {
        return this.map.filter((entry) => probe.every((value, index) => value === null || entry.o[index] === value));
      }

      sync(announce, scroll = true) {
        if (!this.ready) return;
        this.applyExtra();
        const chosen = this.chosen();
        const fromLabel = this.dataset.fromLabel || '';

        for (const group of this.groups) {
          const groupIndex = this.optionIndex(group);
          const isGeneration = group === this.generationGroup;
          for (const input of group.querySelectorAll('input[type="radio"]')) {
            const probe = chosen.slice();
            probe[groupIndex] = input.value;
            // 18-10-2026 (t11b, KRITIEK-RONDE-T18 #1): een AirPods 5-tegel (data-er-extra) kent alleen de condities van zijn eigen
            // producten (Nieuwstaat). Een gekozen conditie die die generatie niet kent (bijv. Goed), telt hier niet mee; anders stond de
            // tegel doorgestreept op 'niet op voorraad' terwijl hij leverbaar is. Kiest de klant de tegel, dan zet applyExtra() de
            // conditie goed. Een echt uitverkochte AirPods 5-variant blijft 'niet op voorraad' (a = false).
            let alleenEigen = false;
            if (isGeneration && input.dataset.erExtra && this.conditionIndex >= 0 && probe[this.conditionIndex] !== null
              && !this.map.some((entry) => entry.o[groupIndex] === input.value
                && entry.o[this.conditionIndex] === probe[this.conditionIndex])) {
              probe[this.conditionIndex] = null;
              alleenEigen = true;
            }
            const found = this.matching(probe);
            const available = found.some((entry) => entry.a === true);
            const label = input.nextElementSibling;
            if (!label) continue;
            label.classList.toggle('is-unavailable', !available);
            const hint = label.querySelector('[data-er-price-hint]');
            const complete = probe.every((value) => value !== null);
            const exact = complete ? found.find((entry) => entry.a === true) : null;
            // 20-09: "Bespaar <bedrag>" op de conditieknop. Het bedrag komt kant-en-klaar uit de winkeldata
            // (veld "s", in Liquid berekend en opgemaakt); hier wordt niets gerekend en niets omgerekend.
            // Leeg zolang de combinatie niet compleet of niet leverbaar is, en altijd leeg bij Nieuwstaat.
            const save = label.querySelector('[data-er-save-hint]');
            if (save) {
              const saveTemplate = this.dataset.saveTemplate || '';
              const amount = exact && typeof exact.s === 'string' ? exact.s : '';
              const saveText = saveTemplate && amount ? saveTemplate.replace('{saving}', amount) : '';
              if (save.textContent !== saveText) save.textContent = saveText;
            }
            if (!hint) continue;
            let text = exact ? exact.p : (!available ? this.dataset.soldOut || '' : '');
            // v2: op de generatietegel de laagste leverbare prijs van het gekozen onderdeel ("vanaf"),
            // zodra alles behalve de conditie gekozen is. Na de conditiekeuze de exacte prijs (hierboven).
            if (!exact && available && isGeneration && this.conditionIndex >= 0 && probe[this.conditionIndex] === null
              && probe.every((value, index) => index === this.conditionIndex || value !== null)) {
              const leverbaar = found
                .filter((entry) => entry.a === true && Number.isInteger(entry.n) && typeof entry.p === 'string')
                .sort((first, second) => first.n - second.n);
              const cheapest = leverbaar[0];
              // 18-10-2026 (AP5-overal): een AirPods 5-tegel heeft per onderdeel één prijs (alleen Nieuwstaat): dan zonder 'vanaf'.
              if (cheapest) text = input.dataset.erExtra && leverbaar.length === 1 ? cheapest.p : `${fromLabel} ${cheapest.p}`.trim();
            }
            // K11 (05-10-2026, ronde K) = F4 ronde H: op een conditietegel de laagste leverbare prijs van die conditie
            // ('vanaf') zolang een andere vraag (de uitvoering) nog open staat; na die keuze de exacte prijs (hierboven).
            // Alleen weergave; niet in de homepage-bestelbox (daar doet v2 de generatietegels) en niet bij een generatievraag
            // (keuzeproduct: 'vanaf' over alle generaties en onderdelen heen is waar maar te breed; KRITIEK-RONDE-K1 klein 3).
            if (!exact && available && group === this.conditionGroup && this.dataset.listenFinder !== 'true'
              && !this.generationGroup
              && probe.some((value, index) => index !== groupIndex && value === null)) {
              const cheapest = found
                .filter((entry) => entry.a === true && Number.isInteger(entry.n) && typeof entry.p === 'string')
                .sort((first, second) => first.n - second.n)[0];
              if (cheapest) text = `${fromLabel} ${cheapest.p}`.trim();
            }
            // 18-10-2026 (t11c, KRITIEK-RONDE-T19 klein 1): toont een AirPods 5-tegel de prijs van zijn eigen conditie terwijl de klant een
            // andere conditie koos, dan staat die eigen conditie erbij ('€89,95 · Nieuwstaat'), uit de kaart en niet als vaste tekst.
            if (alleenEigen && text) {
              const eigen = found.find((entry) => entry.a === true);
              // Ronde U (u2, KRITIEK-RONDE-T20 klein 1): vaste spatie na de punt, zodat een tweede regel '· Nieuwstaat' wordt.
              if (eigen && eigen.o[this.conditionIndex]) text = `${text} ·\u00a0${eigen.o[this.conditionIndex]}`;
            }
            hint.textContent = text;
          }
        }

        this.swapTiles(chosen);
        this.showCompat(chosen);
        const redirectKey = this.caseRedirect(chosen);
        this.explainCondition(chosen);
        this.revealSteps(chosen, announce && scroll, redirectKey);
        this.showRedirect(redirectKey);
        // Ronde U (u1, KRITIEK-RONDE-T19 klein 2): de vanaf-prijs van de koopkaart volgt de keuze (syncFrom hieronder).
        this.syncFrom(chosen, redirectKey);

        if (this.select.disabled) return;
        const complete = !redirectKey && chosen.every((value) => value !== null);
        const variant = complete ? this.map.find((entry) => entry.o.every((value, index) => value === chosen[index])) : null;
        const option = variant && variant.a === true
          ? Array.from(this.select.options).find((entry) => entry.value === variant.id && !entry.disabled)
          : null;
        const next = option ? option.value : '';
        if (this.select.value !== next || announce) {
          this.select.value = next;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (next && variant) {
          this.showMedia(variant, option);
        } else if (!redirectKey) {
          // Foto al wisselen zodra alles behalve de conditie gekozen is (generatie en onderdeel, of Lightning/USB-C):
          // de conditie verandert de foto niet. Gemeten 16-09: wie AirPods 1 en Oplaadcase koos, zag tot de
          // conditiekeuze nog de foto van een oortje.
          const partial = chosen.map((value, index) => (index === this.conditionIndex ? null : value));
          const ready = partial.some((value) => value !== null)
            && partial.every((value, index) => index === this.conditionIndex || value !== null);
          if (ready) {
            const preview = this.matching(partial).find((entry) => entry.m);
            if (preview) this.showMedia(preview, null, partial.filter((value) => value !== null).join(' / '));
          }
        }
        if (this.note) this.note.textContent = complete && !next ? this.dataset.unavailable || '' : '';
        this.dataset.state = next ? 'VARIANT_SELECTED' : complete ? 'UNAVAILABLE' : 'CHOOSING';
      }

      // Ronde U (u1, KRITIEK-RONDE-T19 klein 2): de vanaf-prijs van de koopkaart (er-native-advisory-product) volgt de keuze: uit de
      // kaart de laagste leverbare prijs van wat met de huidige keuze nog mogelijk is, met de conditie waar die prijs bij hoort
      // ('Vanaf €62,80' + 'voor conditie Beperkt'). Alleen als de server een conditiesjabloon meegaf (NL) en er een conditie-optie
      // is. Eén prijs (alle gelijk): zonder 'Vanaf', zoals de server bij één prijs. Bij een doorverwijzing (caseRedirect) of als er
      // voor deze keuze niets leverbaar is: geen prijs ('—', zoals de server zonder leverbare variant) en geen conditieregel; vroeger
      // bleef dan 'Vanaf €23,80' staan, de prijs van iets anders. Alleen weergave: de keuzelijst (name="id"), de prijs van een
      // gekozen variant en de koopweg blijven zoals ze zijn.
      syncFrom(chosen, redirectKey) {
        const host = this.host;
        if (!host || !host.dataset.condTemplate || this.conditionIndex < 0) return;
        if (!this.serverFrom) this.serverFrom = { price: host.dataset.fromPrice || '', cond: host.dataset.fromCond || '' };
        const pool = redirectKey ? [] : this.matching(chosen)
          .filter((entry) => entry.a === true && Number.isInteger(entry.n) && typeof entry.p === 'string')
          .sort((first, second) => first.n - second.n);
        const low = pool[0];
        let price = low ? this.serverFrom.price : '';
        let cond = low ? this.serverFrom.cond : '';
        if (low && low.o[this.conditionIndex]) {
          price = pool.every((entry) => entry.n === low.n) ? low.p : (host.dataset.fromTemplate || '{price}').replace('{price}', low.p);
          cond = host.dataset.condTemplate.replace('{condition}', low.o[this.conditionIndex]);
        }
        host.dataset.fromPrice = price;
        host.dataset.fromCond = cond;
        if (this.select.value) return;
        const out = host.querySelector('[data-native-price]');
        const line = host.querySelector('[data-native-cond]');
        // Zelfde terugval als refresh() in er-native-advisory-product: zonder prijs een streepje.
        const shown = price || '—';
        if (out && out.textContent !== shown) out.textContent = shown;
        if (line && line.textContent !== cond) line.textContent = cond;
      }

      // 18-10-2026 (ronde T, AP5-overal; zijn woord 18-10): een AirPods 5-tegel (data-er-extra; eigen producten met alleen
      // Nieuwstaat) kent niet elke conditie. Condities die bij die generatie niet bestaan, staan niet in beeld; stond er zo een aan,
      // dan vervalt die. Is er na de onderdeelkeuze maar één leverbare conditie, dan staat die aan: er valt niets te kiezen (zelfde
      // regel als bij een optie met één waarde in setup(), en zoals de snelkiezer). Kiest de klant daarna een andere generatie, dan gaat
      // die automatische keuze weer uit en staan alle condities terug. Bij de negen generaties van het keuzeproduct doet dit niets.
      applyExtra() {
        const group = this.conditionGroup;
        if (!group || !this.generationGroup || this.generationIndex < 0 || this.conditionIndex < 0) return;
        const gen = this.generationGroup.querySelector('input[type="radio"]:checked');
        const extra = gen && gen.dataset.erExtra ? gen.value : '';
        const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
        // 18-10-2026 (t11b, KRITIEK-RONDE-T18 klein 1): bij een AirPods 5-tegel staat onder 'Kies de conditie' data-extra-note in plaats
        // van de uitleg van het bespaarbedrag (er is alleen Nieuwstaat); bij een andere generatie komt de oude zin terug. Alleen NL.
        const sub = group.querySelector('.er-native-options__legend-sub');
        if (!extra) {
          radios.forEach((radio) => {
            const item = radio.closest('.er-native-options__item');
            if (item && item.hidden) item.hidden = false;
          });
          if (this.autoCondition && this.autoCondition.checked) this.autoCondition.checked = false;
          this.autoCondition = null;
          if (sub && sub.dataset.erOrig !== undefined && sub.textContent !== sub.dataset.erOrig) sub.textContent = sub.dataset.erOrig;
          return;
        }
        if (sub && this.dataset.extraNote) {
          if (sub.dataset.erOrig === undefined) sub.dataset.erOrig = sub.textContent;
          if (sub.textContent !== this.dataset.extraNote) sub.textContent = this.dataset.extraNote;
        }
        const partGroup = this.partIndex >= 0
          ? this.groups.find((candidate) => this.optionIndex(candidate) === this.partIndex) || null
          : null;
        const partRadio = partGroup ? partGroup.querySelector('input[type="radio"]:checked') : null;
        const part = partRadio ? partRadio.value : null;
        const own = this.map.filter((entry) => entry.o[this.generationIndex] === extra);
        const live = [];
        radios.forEach((radio) => {
          const exists = own.some((entry) => entry.o[this.conditionIndex] === radio.value);
          const item = radio.closest('.er-native-options__item');
          if (item) item.hidden = !exists;
          if (!exists && radio.checked) radio.checked = false;
          if (exists && part !== null && own.some((entry) => entry.o[this.conditionIndex] === radio.value
            && entry.o[this.partIndex] === part && entry.a === true)) live.push(radio);
        });
        if (this.autoCondition && !this.autoCondition.checked) this.autoCondition = null;
        if (live.length === 1 && !radios.some((radio) => radio.checked)) {
          live[0].checked = true;
          this.autoCondition = live[0];
        }
      }

      // 20-09 (eigenaar): de tegel toont het onderdeel dat de klant KOOPT. Kiest hij een oortje, dan het oortje
      // van die generatie; kiest hij de case, dan de case. Tot 20-09 toonde de tegel bewust het andere onderdeel
      // ("dat heb je nog"), maar dat leest als een verkeerde foto. De foto komt uit de map (u), met dezelfde maat
      // als de tegel (width=360). Geen foto voor die combinatie: de statische case-foto blijft staan.
      swapTiles(chosen) {
        if (!this.generationGroup || this.partIndex < 0 || this.generationIndex < 0) return;
        const part = chosen[this.partIndex];
        const partValue = part === null ? '' : part.trim().toLowerCase();
        let wanted = null;
        if (partValue) {
          wanted = [partValue];
        }
        for (const radio of this.generationGroup.querySelectorAll('input[type="radio"]')) {
          const image = radio.nextElementSibling?.querySelector('[data-er-tile-img]');
          if (!image) continue;
          let url = image.dataset.erTileSrc || '';
          if (wanted) {
            const entry = this.map.find((candidate) => candidate.o[this.generationIndex] === radio.value
              && wanted.includes(String(candidate.o[this.partIndex] ?? '').trim().toLowerCase())
              && typeof candidate.u === 'string' && /width=\d+/.test(candidate.u));
            if (entry) url = entry.u.replace(/width=\d+/, 'width=360');
          }
          if (url && image.getAttribute('src') !== url) image.src = url;
        }
      }

      // v2: bevestigingsregel onder de tegels zodra een generatie gekozen is: "Past bij {label}: oortjes
      // {earbuds}, case {case}. {waarschuwing}" uit de embedded JSON van er-model-numbers. Zonder
      // generatiegroep (losse producten) blijft de regel leeg; de productpagina heeft er een statische.
      showCompat(chosen) {
        if (!this.compat) return;
        const radio = this.generationGroup?.querySelector('input[type="radio"]:checked');
        const key = radio?.dataset.erGenKey || '';
        const models = this.models && typeof this.models === 'object' ? this.models.models : null;
        const model = key && models && typeof models === 'object' ? models[key] : null;
        const list = (value) => (Array.isArray(value) ? value.filter((item) => typeof item === 'string').join(' · ') : '');
        if (!model || typeof model.label !== 'string' || chosen.length === 0) {
          this.say(this.compat, '');
          return;
        }
        const template = this.compat.dataset.compatTemplate || '';
        const text = template.replace('{label}', model.label).replace('{earbuds}', list(model.earbuds)).replace('{case}', list(model.case));
        this.say(this.compat, typeof model.warning === 'string' && model.warning ? `${text} ${model.warning}` : text);
      }

      // B11 (19-09-2026): een live-regio moet zichtbaar in de toegankelijkheidsboom staan voordat zijn tekst
      // verandert. Een lege regio is hier visibility: hidden (gereserveerde ruimte, GX/B3); vullen en tonen in
      // dezelfde stap kan de eerste aankondiging kosten. Daarom: leeg en zichtbaar maken, de tekst pas in de
      // volgende frame (dubbele rAF: de lege, zichtbare regio is dan getekend). Een timer zet de tekst alsnog
      // als er geen frame komt; in een verborgen tabblad (geen frames, geen voorlezer) direct, zoals voorheen.
      // Leegmaken en verbergen gaat direct en laat een wachtende tekst vervallen. Staat er al zichtbaar tekst,
      // dan wordt alleen een andere tekst gezet: geen herhaalde aankondiging bij elke volgende keuze.
      say(region, text) {
        if (!region) return;
        if (!(this.saying instanceof Map)) this.saying = new Map();
        const waiting = this.saying.get(region);
        if (waiting) {
          window.cancelAnimationFrame(waiting.frame);
          window.clearTimeout(waiting.timer);
          this.saying.delete(region);
        }
        if (!text) {
          region.textContent = '';
          region.hidden = true;
          return;
        }
        if (!region.hidden && !waiting) {
          if (region.textContent !== text) region.textContent = text;
          return;
        }
        region.textContent = '';
        region.hidden = false;
        if (document.visibilityState === 'hidden') {
          region.textContent = text;
          return;
        }
        const job = { frame: 0, timer: 0 };
        const write = () => {
          if (this.saying.get(region) !== job) return;
          window.cancelAnimationFrame(job.frame);
          window.clearTimeout(job.timer);
          this.saying.delete(region);
          region.textContent = text;
        };
        this.saying.set(region, job);
        job.frame = window.requestAnimationFrame(() => {
          if (this.saying.get(region) === job) job.frame = window.requestAnimationFrame(write);
        });
        job.timer = window.setTimeout(write, 250);
      }

      // Alleen in de homepage-bestelbox: een vraag tegelijk. Een groep verschijnt pas als alle groepen
      // ervoor beantwoord zijn (overgenomen uit Abdul's modelfinder: "twee tikken", niet 17 knoppen tegelijk).
      // Na een keuze komt de eerstvolgende open vraag in beeld, of de toevoegknop als alles gekozen is.
      // De volgorde is de DOM-volgorde (toonvolgorde); de antwoorden worden per optie-index gelezen.
      revealSteps(chosen, announce, redirectKey = '') {
        if (this.dataset.listenFinder !== 'true') return;
        let open = true;
        let next = null;
        this.groups.forEach((group) => {
          const value = chosen[this.optionIndex(group)];
          group.hidden = !open;
          if (open && value === null && !next) next = group;
          if (value === null) open = false;
        });
        if (!announce || !this.stepperReady) {
          this.stepperReady = true;
          return;
        }
        const target = (redirectKey && this.redirect) || next || this.host?.querySelector('[data-native-add]');
        if (!target) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // GX/B3 (18-09): alleen scrollen als het doel niet helemaal in beeld staat. Een scroll die niet nodig is,
        // schuift de knoppen onder de vinger weg (gemeten: 340 px in 0,34 s, een tik viel weg).
        window.requestAnimationFrame(() => {
          if (this.inView(target)) return;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
        });
      }

      // GX/B3: staat het element helemaal in beeld? Veilige rand = de eigen scroll-margin van het doel (bestelbox:
      // 2rem boven, 9.6rem plus de mobiele koopbalk onder) en de onderkant van de sticky header (Dawn .section-header).
      inView(target) {
        const rect = target.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return true;
        const style = window.getComputedStyle(target);
        const marginTop = parseFloat(style.scrollMarginBlockStart || style.scrollMarginTop) || 0;
        const marginBottom = parseFloat(style.scrollMarginBlockEnd || style.scrollMarginBottom) || 0;
        let top = 0;
        const header = document.querySelector('.section-header');
        if (header && window.getComputedStyle(header).position === 'sticky') top = Math.max(0, header.getBoundingClientRect().bottom);
        const height = window.innerHeight || document.documentElement.clientHeight || 0;
        return rect.top >= top + marginTop && rect.bottom <= height - marginBottom;
      }

      caseRedirect(chosen) {
        if (!this.redirect) return '';
        const values = chosen.filter((value) => value !== null).map((value) => value.trim().toLowerCase());
        if (!values.some((value) => this.constructor.PART_VALUES.case.includes(value))) return '';
        const generation = values.find((value) => value.startsWith('airpods'));
        if (!generation) return '';
        if (/\bpro 1\b/.test(generation)) return 'pro1';
        if (/^airpods 3\b/.test(generation)) return 'gen3';
        return '';
      }

      showRedirect(key) {
        if (!this.redirect) return;
        this.redirect.hidden = !key;
        this.redirect.querySelectorAll('[data-er-redirect-link]').forEach((link) => {
          link.hidden = link.dataset.erRedirectLink !== key;
        });
        const conditionGroup = this.conditionGroup;
        if (key) {
          if (this.conditionInfo) this.conditionInfo.hidden = true;
          if (conditionGroup) conditionGroup.hidden = true;
        } else if (conditionGroup && this.dataset.listenFinder !== 'true') {
          conditionGroup.hidden = false;
        }
      }

      // De foto van de gekozen variant vooraan in de galerij, zonder het venster te laten springen. Dawn's eigen
      // setActiveMedia scrolt naar de foto als die boven beeld staat; op een telefoon zou de klant dan wegschieten
      // van de knoppen, vlak voor de toevoegknop.
      showMedia(variant, option, fallbackLabel = '') {
        const mediaId = variant?.m;
        if (!mediaId || mediaId === this.lastMedia) return;
        const sectionId = this.dataset.sectionId;
        const gallery = sectionId ? document.getElementById(`MediaGallery-${sectionId}`) : null;
        const viewer = gallery?.querySelector('[id^="GalleryViewer"]');
        if (!viewer) return;
        const active = viewer.querySelector(`[data-media-id="${sectionId}-${mediaId}"]`);
        if (!active) {
          // Variantfoto's staan niet in de galerij (instelling hide_variants): wissel dan de afbeelding van de
          // eerste foto naar die van de gekozen variant, met dezelfde maten als Shopify zelf aanbiedt.
          const url = typeof variant.u === 'string' ? variant.u : '';
          const image = viewer.querySelector('[data-media-id] img');
          if (!url || !image || !/width=\d+/.test(url)) return;
          this.lastMedia = mediaId;
          // 28-09-2026 (KRITIEK-RONDE-I60 #1): eerst de eigen foto van die slide bewaren; restoreMedia zet hem terug
          // zodra de klant een uitvoering kiest waarvan de foto wel in de galerij staat. Zonder dat bleef bij
          // terugschakelen de foto van de vorige keuze staan (Pro 2-case Lightning/USB-C, keuzeproduct Links/Rechts).
          if (this.swapped?.image !== image) {
            this.restoreMedia();
            this.swapped = { image, srcset: image.getAttribute('srcset'), src: image.getAttribute('src'), alt: image.getAttribute('alt') };
          }
          const width = (size) => url.replace(/width=\d+/, `width=${size}`);
          image.srcset = [480, 720, 960, 1200].map((size) => `${width(size)} ${size}w`).join(', ');
          image.src = width(960);
          const label = option?.dataset?.label || fallbackLabel;
          if (label) image.alt = label;
          return;
        }
        this.lastMedia = mediaId;
        this.restoreMedia();
        viewer.querySelectorAll('[data-media-id]').forEach((element) => element.classList.remove('is-active'));
        active.classList.add('is-active');
        if (active.parentElement.firstElementChild !== active) active.parentElement.prepend(active);
        const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
        const thumb = thumbs?.querySelector(`[data-target="${sectionId}-${mediaId}"]`);
        if (thumb && thumb.parentElement.firstElementChild !== thumb) thumb.parentElement.prepend(thumb);
        thumbs?.querySelectorAll('button').forEach((button) => button.removeAttribute('aria-current'));
        thumb?.querySelector('button')?.setAttribute('aria-current', 'true');
        if (typeof viewer.resetPages === 'function') viewer.resetPages();
        active.parentElement.scrollTo({ left: 0 });
      }

      // Zet de foto terug die showMedia voor een verborgen variantfoto had overschreven (zie daar).
      restoreMedia() {
        const saved = this.swapped;
        if (!saved) return;
        this.swapped = null;
        ['srcset', 'src', 'alt'].forEach((name) => {
          if (saved[name] === null) saved.image.removeAttribute(name);
          else saved.image.setAttribute(name, saved[name]);
        });
      }

      partKind(chosen) {
        const known = this.dataset.partKind;
        if (known === 'case' || known === 'earbud' || known === 'pro') return known;
        const values = chosen.filter((value) => value !== null).map((value) => value.trim().toLowerCase());
        if (values.some((value) => this.constructor.PART_VALUES.case.includes(value))) return 'case';
        if (!values.some((value) => this.constructor.PART_VALUES.earbud.includes(value))) return '';
        const generation = values.find((value) => value.startsWith('airpods'));
        if (!generation) return '';
        return /\bpro\b/.test(generation) ? 'pro' : 'earbud';
      }

      explainCondition(chosen) {
        const info = this.conditionInfo;
        const texts = this.conditionTexts;
        if (!info || !texts || this.conditionIndex < 0) return;
        const value = chosen[this.conditionIndex];
        const key = value === null ? null : this.constructor.CONDITION_KEYS[value.trim().toLowerCase()];
        if (!key || typeof texts[key] !== 'string') {
          this.say(info, '');
          info.classList.remove('is-limited');
          return;
        }
        const kind = key === 'beperkt' ? this.partKind(chosen) : '';
        info.classList.toggle('is-limited', key === 'beperkt');
        this.say(info, kind && typeof texts[kind] === 'string' ? `${texts[key]} ${texts[kind]}` : texts[key]);
      }

      preselect(part) {
        const wanted = this.constructor.FINDER_VALUES[part];
        if (!this.ready || !wanted) return;
        for (const group of this.groups) {
          const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
          const hit = radios.find((radio) => wanted.includes(radio.value.trim().toLowerCase()));
          if (!hit) continue;
          hit.checked = true;
          this.sync(true, false);
          const target = this.closest('[data-er-buybox]') || this;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          return;
        }
      }

      // v2: landen met voorkeuze (advertenties, blog, carrousel, hulppagina): ?onderdeel=links|case|rechts
      // en/of ?model=<sleutel uit er-model-numbers>. Alleen onderdeel en model worden gezet, de conditie
      // nooit. Onbekende waarden worden genegeerd. Daarna dezelfde weg als een tik: sync + bestelbox in beeld.
      applyQuery() {
        let query;
        try {
          query = new URLSearchParams(window.location.search);
        } catch (error) {
          return;
        }
        const part = (query.get('onderdeel') || '').trim().toLowerCase();
        const model = (query.get('model') || '').trim().toLowerCase();
        let hit = false;
        const partKey = Object.prototype.hasOwnProperty.call(this.constructor.QUERY_PARTS, part)
          ? this.constructor.QUERY_PARTS[part]
          : '';
        const wanted = partKey ? this.constructor.FINDER_VALUES[partKey] : null;
        if (wanted) {
          for (const group of this.groups) {
            const radio = Array.from(group.querySelectorAll('input[type="radio"]'))
              .find((candidate) => wanted.includes(candidate.value.trim().toLowerCase()));
            if (!radio) continue;
            radio.checked = true;
            hit = true;
            break;
          }
        }
        if (this.generationGroup && /^[a-z0-9-]{1,32}$/.test(model)) {
          const radio = Array.from(this.generationGroup.querySelectorAll('input[type="radio"]'))
            .find((candidate) => candidate.dataset.erGenKey === model);
          if (radio) {
            radio.checked = true;
            hit = true;
          }
        }
        if (!hit) return;
        this.sync(true, false);
        const target = this.closest('[data-er-buybox]') || this;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.requestAnimationFrame(() => target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["er-pdp-receive"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('er-pdp-receive')) {
    customElements.define('er-pdp-receive', class extends HTMLElement {
      connectedCallback() {
        this.partLine = this.querySelector('[data-er-rc-part]');
        this.modelLine = this.querySelector('[data-er-rc-model]');
        this.fitLine = this.querySelector('[data-er-rc-fit]');
        this.hint = this.querySelector('[data-er-rc-hint]');
        const source = this.querySelector('[data-er-rc-data]');
        // Geen tabel = de combinatie verschilt niet per variant: de server-tekst is al definitief.
        if (!this.partLine || !this.modelLine || !this.fitLine || !this.hint || !source) return;
        try {
          this.data = JSON.parse(source.textContent || 'null');
        } catch {
          this.data = null;
        }
        if (!this.data || typeof this.data !== 'object') return;
        if (!this.data.v || typeof this.data.v !== 'object' || !this.data.p || !Array.isArray(this.data.g)) return;
        this.abort?.abort();
        this.abort = new AbortController();
        this.listen();
        // De keuzelijst staat in een eerder blok en is dus al geparsed; dit is alleen een terugval.
        if (!this.select) {
          document.addEventListener('DOMContentLoaded', () => this.listen(), { once: true, signal: this.abort.signal });
        }
      }

      disconnectedCallback() {
        this.abort?.abort();
      }

      // Alleen meelezen met de bestaande keuzelijst van de koopstraat; nooit zelf iets zetten.
      listen() {
        if (this.select) return;
        const scope = this.closest('.product__info-container') || document;
        this.select =
          scope.querySelector('er-native-advisory-product [data-native-variant]') ||
          document.querySelector('er-native-advisory-product [data-native-variant]');
        if (!this.select) return;
        this.select.addEventListener('change', () => this.update(), { signal: this.abort.signal });
        this.update();
      }

      update() {
        const id = String(this.select?.value || '');
        // 18-10-2026 (AP5-overal): een AirPods 5-regel uit de kiezer (eigen product) heeft zijn eigen drie regels (JSON "x", 6d).
        const extra = /^[0-9]+$/.test(id) && this.data.x && typeof this.data.x === 'object' && Array.isArray(this.data.x[id])
          ? this.data.x[id] : null;
        if (extra) {
          this.say(this.partLine, typeof extra[0] === 'string' ? extra[0] : '');
          this.say(this.modelLine, typeof extra[1] === 'string' ? extra[1] : '');
          this.say(this.fitLine, typeof extra[2] === 'string' ? extra[2] : '');
          this.hint.hidden = true;
          return;
        }
        const pair = /^[0-9]+$/.test(id) && typeof this.data.v[id] === 'string' ? this.data.v[id] : '';
        if (pair.length !== 2) {
          this.clear();
          return;
        }
        const part = this.data.p[pair.charAt(0)];
        if (typeof part !== 'string' || part === '') {
          this.clear();
          return;
        }
        const index = '012345678'.indexOf(pair.charAt(1));
        const gen = index >= 0 && this.data.g[index] && typeof this.data.g[index] === 'object' ? this.data.g[index] : null;
        const label = gen && typeof gen.l === 'string' ? gen.l : '';
        // 28-09-2026 (I2.90): bij een los oortje het nummer van die kant (er-kant-nummers), anders alle nummers.
        const side = pair.charAt(0);
        let numbers = '';
        if (gen) {
          // 29-09-2026 (KRITIEK-RONDE-I68 #1): bij de AirPods 3-case het nummer van de gekozen uitvoering (JSON "n").
          if (side === 'c') numbers = this.data.n && typeof this.data.n[id] === 'string' && this.data.n[id] !== '' ? this.data.n[id] : gen.c;
          else if (side === 'l' && typeof gen.ml === 'string' && gen.ml !== '') numbers = gen.ml;
          else if (side === 'r' && typeof gen.mr === 'string' && gen.mr !== '') numbers = gen.mr;
          else numbers = gen.m;
        }
        const receive = label
          ? String(this.dataset.rcReceive || '').replace('{part}', part).replace('{gen}', label)
          : String(this.dataset.rcReceivePlain || '').replace('{part}', part);
        const model =
          typeof numbers === 'string' && numbers !== ''
            ? String(this.dataset.rcModel || '').replace('{models}', numbers)
            : '';
        const warning = gen && typeof gen.w === 'string' && gen.w !== '' ? gen.w : String(this.dataset.rcFit || '');
        this.say(this.partLine, receive);
        this.say(this.modelLine, model);
        this.say(this.fitLine, warning);
        this.hint.hidden = true;
      }

      // Staat het onderdeel al vast (Pro 2 / AirPods 4: alleen de uitvoering varieert), dan blijft
      // die regel staan zolang er niets gekozen is; anders poetst dit de server-tekst uit 6b meteen
      // weg. Bewust rechtstreeks schrijven en niet via say(): dit is geen nieuwe melding in de
      // live-regio, maar het terugzetten van de begintekst.
      clear() {
        const base = String(this.dataset.rcBase || '');
        // Een wachtende schrijfbeurt uit say() eerst laten vervallen, anders zet die de zojuist
        // gewiste regel een frame later alsnog terug (kant van bevinding 4 die clear() raakt).
        for (const line of [this.partLine, this.modelLine, this.fitLine]) this.cancelSay(line);
        // 29-09-2026 (KRITIEK-RONDE-I68 #1): bij de AirPods 3-case zijn het modelnummer (beide nummers) en de pasregel al de
        // begintekst (data-rc-base-model/-fit); die komen dan terug. Elders zijn ze leeg en verdwijnen de regels zoals voorheen.
        const bases = [
          [this.modelLine, String(this.dataset.rcBaseModel || '')],
          [this.fitLine, String(this.dataset.rcBaseFit || '')],
        ];
        for (const [line, text] of bases) {
          line.hidden = text === '';
          if (line.textContent !== text) line.textContent = text;
        }
        this.partLine.hidden = base === '';
        // 28-09-2026 (I2.196, KRITIEK-RONDE-I55 #2): alleen schrijven als de begintekst anders is; textContent zetten vervangt
        // de tekstknoop en een schermlezer meldt de regel dan bij elke tik opnieuw.
        if (this.partLine.textContent !== base) this.partLine.textContent = base;
        // I-68: een lege uitnodiging (AirPods 3-case, tekst vóór de keuze al volledig) blijft verborgen; elders heeft hij tekst.
        this.hint.hidden = this.hint.textContent.trim() === '';
      }

      cancelSay(line) {
        if (!line || !(this.saying instanceof Map)) return;
        const waiting = this.saying.get(line);
        if (!waiting) return;
        window.cancelAnimationFrame(waiting.frame);
        window.clearTimeout(waiting.timer);
        this.saying.delete(line);
      }

      // B11 (19-09): eerst zichtbaar maken, de tekst een frame later, zodat een schermlezer de eerste
      // melding in de live-regio niet mist. Altijd textContent, nooit innerHTML.
      // Bevinding 4 uit REVIEW-R4.md (20-09): requestAnimationFrame vuurt niet in een verborgen of
      // voorgerenderd tabblad. Zonder terugval werden de drie regels dan wel zichtbaar maar bleven ze
      // leeg. Daarom dezelfde twee beveiligingen als er-native-options.say() (regel 810-826 daar):
      // in een verborgen tabblad meteen schrijven, en anders een timer van 250 ms naast het frame.
      // De wachtende taak per regel wordt bijgehouden, zodat een nieuwe keuze de oude laat vervallen
      // en frame en timer elkaar niet dubbel uitvoeren.
      say(line, text) {
        if (!line) return;
        if (!(this.saying instanceof Map)) this.saying = new Map();
        const waiting = this.saying.get(line);
        if (waiting) this.cancelSay(line);
        if (!text) {
          line.hidden = true;
          line.textContent = '';
          return;
        }
        // 28-09-2026 (I2.196, KRITIEK-RONDE-I55 #2): dezelfde tekst die al zichtbaar staat niet opnieuw schrijven (zoals
        // er-native-options.say()); anders meldt de live-regio bij elke conditiekeuze drie ongewijzigde regels opnieuw.
        if (!line.hidden && line.textContent === text) return;
        line.hidden = false;
        if (document.visibilityState === 'hidden' || typeof window.requestAnimationFrame !== 'function') {
          line.textContent = text;
          return;
        }
        const job = { frame: 0, timer: 0 };
        const write = () => {
          if (this.saying.get(line) !== job) return;
          window.cancelAnimationFrame(job.frame);
          window.clearTimeout(job.timer);
          this.saying.delete(line);
          line.textContent = text;
        };
        this.saying.set(line, job);
        job.frame = window.requestAnimationFrame(write);
        job.timer = window.setTimeout(write, 250);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["er-snel-toevoegen"] && !Shopify.designMode) return;
  try {
    /* Snel toevoegen met conditie Goed (G11, 26-09-2026). Dezelfde route als sections/er-case-cards.liquid:
     adrescontrole, dezelfde body met _er_native_route, dezelfde foutmeldingen in de aria-live-regel. Na HTTP 200
     naar de winkelwagen (data-cart-url, gecontroleerd zoals in er-native-advisory-product), waar de klant de
     conditie kan wisselen. Een of twee knoppen per kaart (per uitvoering): een pad, de knop draagt de variant.
     Er wordt niets aan het productformulier, de select of de bewaker gewijzigd. */
  if (!customElements.get('er-snel-toevoegen')) {
    class ERSnelToevoegen extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.pending = false;
        this.status = this.querySelector('[data-er-snel-status]');
        this.onClick = (event) => {
          const button = event.target instanceof Element ? event.target.closest('[data-er-snel-add]') : null;
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          this.addToCart(button);
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.onClick) this.removeEventListener('click', this.onClick);
        this.bound = false;
      }

      endpoint(value, suffix) {
        let url;
        try {
          url = new URL(value || '', window.location.origin);
        } catch (error) {
          return null;
        }
        if (url.origin !== window.location.origin || !url.pathname.endsWith(suffix) || url.search || url.hash) return null;
        return url;
      }

      // De winkelwagen waar de klant heen gaat: zelfde oorsprong, zelfde pad als de toevoegroute zonder /add.js,
      // hooguit ?view=er-native-advisory-v1 (dezelfde controle als de koopknop op de productpagina).
      destination(addUrl) {
        let url;
        try {
          url = new URL(this.dataset.cartUrl || '', window.location.origin);
        } catch (error) {
          return null;
        }
        if (url.origin !== window.location.origin || url.pathname !== addUrl.pathname.replace(/\/add\.js$/, '') || url.hash) return null;
        if (url.search !== '' && url.search !== '?view=er-native-advisory-v1') return null;
        return url.href;
      }

      say(text) {
        if (this.status) this.status.textContent = text;
      }

      buttons() {
        return Array.from(this.querySelectorAll('[data-er-snel-add]'));
      }

      async addToCart(button) {
        const variantId = button.getAttribute('data-er-variant-id') || '';
        const productId = button.getAttribute('data-er-product-id') || '';
        const addUrl = this.endpoint(this.dataset.addUrl, '/cart/add.js');
        const destination = addUrl ? this.destination(addUrl) : null;
        if (this.pending || !addUrl || !destination || !/^[1-9][0-9]*$/.test(variantId) || !Number.isSafeInteger(Number(variantId))) return;
        this.pending = true;
        // Bij twee knoppen gaan beide dicht: een toevoeging tegelijk, en de tweede uitvoering hoort er niet bij.
        this.buttons().forEach((entry) => { entry.disabled = true; });
        button.setAttribute('aria-busy', 'true');
        this.say(this.dataset.busy || '');

        const body = { id: Number(variantId), quantity: 1, properties: { _er_native_route: 'er-native-advisory/1' } };
        let message = this.dataset.error || '';
        try {
          const response = await fetch(addUrl.href, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          if (response.ok) {
            // Identiteitscontrole zoals op de productpagina: het antwoord moet deze variant van dit product zijn.
            let match = true;
            try {
              const data = await response.json();
              const item = data && Array.isArray(data.items) ? data.items[0] : data;
              match = !!item && String(item.variant_id ?? item.id) === variantId && (productId === '' || String(item.product_id) === productId);
            } catch (error) {
              // geen leesbaar antwoord bij HTTP 200: de winkelwagen zelf laat zien wat er is toegevoegd
            }
            if (match) {
              this.say(this.dataset.added || '');
              window.location.assign(destination);
              return;
            }
          } else {
            try {
              const data = await response.json();
              if (data && typeof data.description === 'string' && data.description.trim() !== '') message = data.description;
            } catch (error) {
              // geen JSON-body: de standaardmelding blijft staan
            }
          }
        } catch (error) {
          // netwerkfout: de standaardmelding blijft staan
        }
        this.pending = false;
        this.buttons().forEach((entry) => { entry.disabled = false; });
        button.removeAttribute('aria-busy');
        this.say(`${message} ${this.dataset.uncertain || ''}`.trim());
      }
    }

    customElements.define('er-snel-toevoegen', ERSnelToevoegen);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["er-sticky-buy"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.erStickyBuyLoaded) return;
    window.erStickyBuyLoaded = true;

    const init = () => {
      const bar = document.querySelector('[data-er-sticky]');
      if (!bar || bar.dataset.erStickyReady === 'true') return;
      // De koopweg: het eerste advisory-element met keuzelijst, prijs en echte knop. Ontbreekt die (ander
      // profiel, ander sjabloon), dan blijft de balk verborgen en doet dit script niets.
      const host = Array.from(document.querySelectorAll('er-native-advisory-product')).find((candidate) =>
        candidate.querySelector('[data-native-variant]') && candidate.querySelector('[data-native-price]')
        && candidate.querySelector('[data-native-add]'));
      if (!host) return;
      const select = host.querySelector('[data-native-variant]');
      const price = host.querySelector('[data-native-price]');
      const add = host.querySelector('[data-native-add]');
      const name = bar.querySelector('[data-er-sticky-name]');
      const amount = bar.querySelector('[data-er-sticky-price]');
      const go = bar.querySelector('[data-er-sticky-go]');
      if (!(select instanceof HTMLSelectElement) || !price || !add || !name || !amount || !go) return;
      bar.dataset.erStickyReady = 'true';

      let addInView = true;
      let bodyPadding = '';
      // Keuzestand (alleen met prechoice): nog geen keuze en de hele koopkaart staat boven of (K10, 05-10-2026) onder het beeld.
      const prechoice = bar.hasAttribute('data-er-sticky-prechoice');
      // 7b (ronde M, 09-10-2026): meteen toevoegen met direct: true (productpagina; sinds ronde N ook de homepage-bestelbox) en
      // alleen waar de echte knop kan kopen
      // (gepubliceerd thema; in een voorvertoning staat die knop uit: data-preview-only). Anders 'Naar bestellen' zoals voorheen.
      const direct = bar.hasAttribute('data-er-sticky-direct') && host.dataset.previewOnly === 'false';
      const buyLabel = direct && bar.dataset.erStickyAddGo ? bar.dataset.erStickyAddGo : go.textContent;
      const status = host.querySelector('[data-native-status]');
      let watching = null;
      let releaseTimer = 0;
      const pickLabel = bar.dataset.erStickyPickGo || buyLabel;
      let hostAbove = false;
      let hostBelow = false;

      const chosen = () => {
        if (select.value === '') return null;
        const option = Array.from(select.options).find((entry) => entry.value === select.value);
        return option && !option.disabled ? option : null;
      };

      const fit = () => {
        const height = Math.ceil(bar.getBoundingClientRect().height);
        document.body.style.paddingBottom = `${height}px`;
        document.body.style.setProperty('--er-sticky-buy-h', `${height}px`);
      };

      const apply = () => {
        const option = chosen();
        const pick = prechoice && !option && (hostAbove || hostBelow);
        const show = pick || (!!option && !addInView);
        if (option) {
          const label = typeof option.dataset.label === 'string' && option.dataset.label.trim() !== ''
            ? option.dataset.label.trim() : option.textContent.trim();
          // Product met één uitvoering: Shopify noemt die "Default Title"; toon dan de productnaam.
          const shown = label === 'Default Title' ? (bar.dataset.erStickyTitle || '') : label;
          if (name.textContent !== shown) name.textContent = shown;
          // L1.14 (ronde L): de korte prijs van de gekozen optie (data-money-short, '€38,95'), zoals de pagina zelf; het prijsveld
          // kon nog de lange notatie ('€38,95 EUR') tonen. Zonder data-money-short: het prijsveld zoals voorheen.
          const short = typeof option.dataset.moneyShort === 'string' ? option.dataset.moneyShort.trim() : '';
          const money = short !== '' ? short : price.textContent.trim();
          if (amount.textContent !== money) amount.textContent = money;
          if (go.textContent !== buyLabel) go.textContent = buyLabel;
          bar.dataset.erStickyMode = 'buy';
        } else if (pick) {
          // De eigen teksten van de kaart: de lege optie ("Kies een uitvoering") en de vanaf-prijs.
          // L1.14 (ronde L): de vraag die nog open staat (legend van de eerste zichtbare groep zonder keuze, bijv. 'Kies de
          // conditie'); zonder zo'n groep de lege optie van de keuzelijst zoals voorheen.
          const openGroup = Array.from(host.querySelectorAll('.er-native-options__group'))
            .filter((group) => !group.hidden && group.getClientRects().length > 0)
            .find((group) => !group.querySelector('input:checked'));
          const legend = openGroup ? openGroup.querySelector('legend') : null;
          const legendText = legend ? legend.textContent.replace(/\s+/g, ' ').trim() : '';
          const empty = Array.from(select.options).find((entry) => entry.value === '');
          const label = legendText !== '' ? legendText : (empty ? empty.textContent.trim() : '');
          if (name.textContent !== label) name.textContent = label;
          const money = price.textContent.trim();
          if (amount.textContent !== money) amount.textContent = money;
          if (go.textContent !== pickLabel) go.textContent = pickLabel;
          bar.dataset.erStickyMode = 'pick';
        }
        if (show === !bar.hidden) {
          if (show) fit();
          return;
        }
        if (show) {
          bodyPadding = document.body.style.paddingBottom;
          bar.hidden = false;
          document.body.classList.add('er-sticky-buy-active');
          fit();
        } else {
          bar.hidden = true;
          document.body.classList.remove('er-sticky-buy-active');
          document.body.style.paddingBottom = bodyPadding;
          document.body.style.removeProperty('--er-sticky-buy-h');
        }
      };

      // 23-10-2026 (ronde W, w11): 'in beeld' = boven Shopify's cookiemelding (--er-melding-h, snippets/er-melding-hoogte). Lag
      // de echte knop of de koopkaart onder de melding, dan verdween de balk terwijl er niets te zien was om op te tikken. Beide
      // waarnemers krijgen de hoogte van de melding als extra ondermarge en worden opnieuw gezet als die verandert (bericht
      // er:melding-hoogte); zonder melding is die marge 0, zoals voorheen.
      const melding = () => Math.round(parseFloat(document.documentElement.style.getPropertyValue('--er-melding-h')) || 0);
      let waarnemers = [];
      const volg = () => {
        if (!('IntersectionObserver' in window)) return;
        waarnemers.forEach((w) => w.disconnect());
        waarnemers = [];
        const onder = melding();
        const opKnop = new IntersectionObserver((entries) => {
          for (const entry of entries) addInView = entry.isIntersecting;
          apply();
        }, { threshold: 0, rootMargin: '0px 0px -' + onder + 'px 0px' });
        opKnop.observe(add);
        waarnemers.push(opKnop);
        if (!prechoice) return;
        const opKaart = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            hostAbove = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            // L1.11 (ronde L): 'onder beeld' tot er meer dan 120 px van de kaart zichtbaar is (rootMargin hieronder), anders
            // verdween de balk al bij 1 px kaartrand zonder vraag of knop in beeld (Pro 2-case, 375x812: kaart op 810,8 px).
            hostBelow = !entry.isIntersecting && entry.boundingClientRect.top >= (window.innerHeight || 0) - 120 - onder;
          }
          apply();
        }, { threshold: 0, rootMargin: '0px 0px -' + (120 + onder) + 'px 0px' });
        opKaart.observe(host);
        waarnemers.push(opKaart);
      };
      volg();
      document.addEventListener('er:melding-hoogte', volg);
      if (prechoice) {
        // Een sprong (anker, terugknop) van onder naar boven de kaart kruist nooit de drempel van de observer;
        // daarom meet een lichte scroll-luisteraar (hooguit één keer per frame) dezelfde toestand opnieuw.
        let queued = false;
        const measure = () => {
          queued = false;
          const rect = host.getBoundingClientRect();
          const above = rect.bottom <= 0;
          const below = rect.top >= (window.innerHeight || 0) - 120 - melding();
          if (above !== hostAbove || below !== hostBelow) {
            hostAbove = above;
            hostBelow = below;
            apply();
          }
        };
        window.addEventListener('scroll', () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(measure);
        }, { passive: true });
      }
      if ('MutationObserver' in window) {
        new MutationObserver(() => apply()).observe(price, { childList: true, characterData: true, subtree: true });
      }
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => { if (!bar.hidden) fit(); }).observe(bar);
      }
      // Na change eerst de advisory-snippet zijn prijs laten zetten (zelfde event), dan pas lezen.
      select.addEventListener('change', () => queueMicrotask(apply));
      // 7b: na een tik wacht de balk op de melding van de koopstraat ([data-native-status], role="status"). 'Toegevoegd': de
      // koopstraat gaat zelf naar de winkelwagen. Een andere melding (fout of onzeker) staat bij de echte knop: de knop van de balk
      // is dan weer vrij en die melding komt in beeld. Vangnet: na 10 s is de knop van de balk hoe dan ook weer vrij.
      const release = () => {
        if (watching) watching.disconnect();
        watching = null;
        window.clearTimeout(releaseTimer);
        go.removeAttribute('aria-disabled');
      };
      const watch = () => {
        release();
        go.setAttribute('aria-disabled', 'true');
        releaseTimer = window.setTimeout(release, 10000);
        if (!status || !('MutationObserver' in window)) return;
        watching = new MutationObserver((records, observer) => {
          const text = status.textContent.trim();
          if (text === '') return;
          if (text === (host.dataset.added || '').trim()) {
            observer.disconnect();
            return;
          }
          release();
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          status.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        });
        watching.observe(status, { childList: true, characterData: true, subtree: true });
      };
      window.addEventListener('pageshow', (event) => {
        // 7b: terug via de terugknop uit de bfcache: de knop van de balk weer vrij.
        if (event.persisted) release();
        queueMicrotask(apply);
      });

      go.addEventListener('click', () => {
        // 7b: de koopstraat is na een tik op de balk nog bezig; een tweede tik doet niets.
        if (go.getAttribute('aria-disabled') === 'true') return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const behavior = reduce ? 'auto' : 'smooth';
        if (bar.dataset.erStickyMode === 'pick') {
          // l3f (KRITIEK-RONDE-L6 #1b): toont de kaart de omleiding naar een casepagina (keuzeproduct, Oplaadcase + AirPods 3 of
          // AirPods Pro 1), dan is dat de enige weg verder: daarheen, met de focus op de zichtbare link.
          const redirect = host.querySelector('[data-er-options-redirect]');
          if (redirect && !redirect.hidden && redirect.getClientRects().length > 0) {
            redirect.scrollIntoView({ block: 'center', behavior });
            const link = Array.from(redirect.querySelectorAll('a[href]')).find((entry) => !entry.hidden);
            if (link) link.focus({ preventScroll: true });
            return;
          }
          // Naar de eerste zichtbare vraag zonder antwoord; de balk kiest zelf niets.
          const groups = Array.from(host.querySelectorAll('.er-native-options__group'))
            .filter((group) => !group.hidden && group.getClientRects().length > 0);
          const open = groups.find((group) => !group.querySelector('input:checked')) || groups[0] || host;
          open.scrollIntoView({ block: 'center', behavior });
          const first = open.querySelector('input:not([disabled]), button:not([disabled])');
          if (first) first.focus({ preventScroll: true });
          return;
        }
        // 7b (ronde M, m2; ja van de eigenaar 09-10-2026): in de koopstand (productpagina en, sinds ronde N, de homepage-bestelbox)
        // legt de balk het product meteen in de
        // wagen door de echte knop aan te klikken: dezelfde koopweg als een tik op die knop, met dezelfde controles in submit().
        if (direct && !add.disabled) {
          watch();
          add.click();
          return;
        }
        add.scrollIntoView({ block: 'center', behavior });
        add.focus({ preventScroll: true });
      });

      apply();
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
